namespace Application.Models {
    'use strict';

    export interface IManagementInfo {
        result: IManagementInfoResult;
        error: IManagementInfoError;
    }

    export class ManagementInfo {
        public result: IManagementInfoResult;
        public error: IManagementInfoError;

        public static createEmpty(): ManagementInfo {
            return new ManagementInfo();
        }
    }

    export interface IManagementInfoResult {
        url: string;
    }

    export interface IManagementInfoError {
        code: number;
        message: string;
    }
}